/* Custom cursor: orange dot + trailing ring. Desktop fine-pointer only. */
(function () {
  var mq = window.matchMedia;
  if (!mq) return;
  if (!mq('(hover: hover) and (pointer: fine)').matches) return;
  if (mq('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var dot = document.createElement('div'); dot.className = 'cursor-dot';
  var ring = document.createElement('div'); ring.className = 'cursor-ring';
  document.body.appendChild(ring);
  document.body.appendChild(dot);
  root.classList.add('has-custom-cursor');

  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my, active = false;

  window.addEventListener('mousemove', function (e) {
    mx = e.clientX; my = e.clientY;
    dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    if (!active) { active = true; root.classList.add('cursor-active'); }
  }, { passive: true });

  (function loop() {
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
    requestAnimationFrame(loop);
  })();

  var sel = 'a,button,.btn,[role="button"],.nav-link,.nav-dropdown-link,.drawer-link,.drawer-sub-link,.header-action-btn,.mob-nav-item,.product-card,.category-card,.collection-tile,.gallery-thumb,.pay-chip,.variant-swatch,.hero-cta-main,.hero-cta-ghost,.feature-banner__cta,.promo-cta';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(sel)) root.classList.add('cursor-hover');
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(sel)) {
      var to = e.relatedTarget;
      if (!(to && to.closest && to.closest(sel))) root.classList.remove('cursor-hover');
    }
  }, { passive: true });
  document.addEventListener('mousedown', function () { root.classList.add('cursor-down'); }, { passive: true });
  document.addEventListener('mouseup', function () { root.classList.remove('cursor-down'); }, { passive: true });
  document.addEventListener('mouseleave', function () { root.classList.remove('cursor-active'); }, { passive: true });
  document.addEventListener('mouseenter', function () { root.classList.add('cursor-active'); }, { passive: true });
})();
